import AuthGate from './components/AuthGate';
import Dashboard from './components/Dashboard';

/**
 * App.jsx - 진입점
 *
 * AuthGate가 인증 안 된 사용자에게 로그인 화면을 표시.
 * 인증 완료 후 Dashboard 렌더링.
 */
export default function App() {
  return (
    <AuthGate>
      <Dashboard />
    </AuthGate>
  );
}
